import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {IOrientationInitialState, IOrientationPayload} from "../types";
import {GetDeleteOrientation,GetOrientation} from "../store/thunk";



const initialState: IOrientationInitialState = {
    orientation: [],
    filterOrientation: [],
    isLoadingOrientation:true,
    isViewRestoreOrientation:false,
    restoreOrientation:[],
    selectedIDsOrientation:[]
}

const orientationSlice = createSlice({
    name: "orientation",
    initialState,
    reducers: {
        setOrientation: (state, action: PayloadAction<{
            data: IOrientationPayload[],
            defaultLanguage: string
        }>) => {
            const {data, defaultLanguage} = action.payload
            state.orientation = data.map((year) => ({
                id: year.id,
                translations: year.translations.map((translation) => ({
                    slug: translation.slug,
                    name: translation.name,
                    abbreviation:translation.abbreviation,
                })),
            }));
            state.filterOrientation = state.orientation.flatMap(
                (data) =>
                    data.translations
                        .filter((elem) => elem.slug === defaultLanguage && elem.name)
                        .map((elem) => ({
                            id: data.id,
                            name: elem.name as string ?? "",
                            abbreviation:elem.abbreviation ?? "",
                        }))
            );

        },
        deletedOrientation: (state, action: PayloadAction<number>) => {
            state.orientation = state.orientation.filter(
                ({ id }) => id !== action.payload
            );
        },
        setIsViewOrientation:(state)=>{
            state.isViewRestoreOrientation =!state.isViewRestoreOrientation;
        },
        setOrientationRestore:(state, action) => {
            state.restoreOrientation = action.payload;
        },
        deletedRestoreOrientation: (state, action) => {
            state.restoreOrientation = state.restoreOrientation.filter(
                ({ id }) => id !== action.payload
            );
        },
        setSelectedOrientationIDs: (state, action) => {
            state.selectedIDsOrientation=action.payload
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(GetOrientation.pending, (state) => {
                state.isLoadingOrientation = true;
            })
            .addCase(GetOrientation.fulfilled, (state) => {
                state.isLoadingOrientation = false;
            })
            .addCase(GetOrientation.rejected, (state) => {
                state.isLoadingOrientation = false;
            })
            .addCase(GetDeleteOrientation.pending, (state) => {
                state.isLoadingOrientation = true;
            })
            .addCase(GetDeleteOrientation.fulfilled, (state) => {
                state.isLoadingOrientation = false;
            })
            .addCase(GetDeleteOrientation.rejected, (state) => {
                state.isLoadingOrientation = false;
            });
    },
})

export const{
    setOrientation,
    deletedOrientation,
    setOrientationRestore,
    deletedRestoreOrientation,
    setSelectedOrientationIDs,
    setIsViewOrientation
} =orientationSlice.actions


export default orientationSlice